import React from "react";

export const TaskDetailContext = React.createContext(null);

export const useTaskDetailContext = () => {
  const context = React.useContext(TaskDetailContext);

  if (!context) throw new Error("Task Detail Context not provided!");

  return context;
};
